const ContentActionType = {
    CreateDocument: 0,
    AddAttachment: 1,

    0: 'CreateDocument',
    1: 'AddAttachment',
};

export default ContentActionType;